import React, { memo } from "react"
import { Box, Text } from "@chakra-ui/react"

import type { ProductCombinedProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
}

export const ProductContentTitle: React.FC<Props> = memo(({ product }) => (
  <Box flex={1}>
    <Text as="h1" size="3xl" fontSize={{ base: "1.5rem", sm: "3xl" }} color="grey.text" whiteSpace={"pre-wrap"}>
      {product?.title}
    </Text>
    {product?.tagline?.tagline && (
      <Text color="grey.text" lineHeight={1.5} mt={2} letterSpacing="0.75px">
        {product?.tagline?.tagline}
      </Text>
    )}
  </Box>
))
